<template>
  <div class="com-dimensional-list">
    <div class="com-dimensional-list__header mb16">
      {{ name }}
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    name: String
  }
};
</script>

<style lang="scss" scoped>
  .com-dimensional-list {
    padding: 16px 18px;
    border: 1px solid #E9E9E9;
    background: #FFFFFF;
    border-radius: 4px;
    &__header {
      font-size: 14px;
      font-weight: 500;
      color: #262626;
      line-height: 22px;
    }
  }
</style>
